import { $el, $list } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const ACTIVE_FILTERS_OPTIONS_SELECTOR = `[data-shop-active-filters-options]`
const ACTIVE_FILTERS_REMOVE_BTN_SELECTOR = `[data-filter-remove-btn]`

export class ShopActiveFilters extends BaseComponent {
  reset(): void {
    this.replaceChildren()
  }

  setDisable(): void {
    const options = $el(ACTIVE_FILTERS_OPTIONS_SELECTOR, this)
    options?.setAttribute('disabled', '')
  }

  get buttons(): Element[] {
    return $list(ACTIVE_FILTERS_REMOVE_BTN_SELECTOR, this)
  }
}
